import { GroupDividerLayout } from '@/components/table/group-divider-layout';
import { StartDateTimeRangeGroupKey } from '@/lib/table-grouping-utils';
import { formatDateWithDayOfWeek, formatTimeRange } from '@airreading/common';

interface SessionDateTimeDividerProps {
  groupKey: StartDateTimeRangeGroupKey;
  rowCount: number;
}

export function SessionDateTimeDivider({ groupKey, rowCount }: SessionDateTimeDividerProps) {
  return (
    <GroupDividerLayout rowCount={rowCount}>
      {formatDateWithDayOfWeek(groupKey.startInstant, groupKey.timeZone)}{' '}
      {formatTimeRange(groupKey.startInstant, groupKey.endInstant, groupKey.timeZone)}
    </GroupDividerLayout>
  );
}
